import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import styles from 'styles/Course.module.scss';
import classnames from 'classnames';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import {
  MdEditNote,
  MdSync,
  MdCheckCircleOutline,
  MdOutlineMilitaryTech,
} from 'react-icons/md';
import { getSelectedCentre } from 'store/master';
import { handleToastError } from 'helpers';
import badgeApi from 'api/badgeApi';
import reportApi from 'api/reportApi';
import { useSelector } from 'react-redux';
import { useUser } from '../../../hooks';

const ClassStatistics = ({ setTotalClass }) => {
  const router = useRouter();
  const auth = useUser();
  const selectedCentre = useSelector(getSelectedCentre);
  const [intakecount, setIntakeCount] = useState({});

  async function StatisticsCount() {
    try {
      const response = await reportApi.getDonutChartValue(
        auth?._id,
        selectedCentre?._id ? { courseCentre: selectedCentre?._id } : null,
      );
      setTotalClass(
        response.coursesNotStarted +
          +response.coursesInProgress +
          +response.completedCourses,
      );
      return {
        coursesNotStarted: response.coursesNotStarted,
        coursesInProgress: response.coursesInProgress,
        completedCourses: response.completedCourses,
      };
    } catch (error) {
      handleToastError(error);
    }
  }

  const getUserBadge = async () => {
    try {
      const response = await badgeApi.getUserBadges(
        auth?._id,
        selectedCentre?._id ? { courseCentre: selectedCentre?._id } : null,
      );
      if (response?.length) {
        let badgeArray = [];
        response?.map((data) => {
          if (data?.badgeEnabled) {
            if (data?.allowDuplicateBadgeCount > 1) {
              [...Array(data?.allowDuplicateBadgeCount)].map((item, ii) => {
                badgeArray.push(data);
              });
            } else {
              badgeArray.push(data);
            }
          }
        });
        return { badgeCount: badgeArray?.length };
      }
    } catch (e) {
      handleToastError(e);
    }
  };

  useEffect(() => {
    (async () => {
      let promise = await Promise.all([StatisticsCount(), getUserBadge()]);
      setIntakeCount({ ...promise[0], ...promise[1] });
    })();
  }, [selectedCentre]);

  const cardsData = [
    {
      card: [
        {
          icon: <MdEditNote className="left-icon" />,
          title: 'Classes Not Started',
          count: 'coursesNotStarted',
          route: `/intakes/intake-grid?status=ACTIVE`,
        },
        {
          icon: <MdSync className="left-icon" />,
          title: 'Classes In Progress',
          count: 'coursesInProgress',
          route: `/intakes/intake-grid?status=IN_PROGRESS`,
        },
      ],
    },
    {
      card: [
        {
          icon: <MdCheckCircleOutline className="left-icon" />,
          title: 'Classes Completed',
          count: 'completedCourses',
          route: `/intakes/intake-grid?status=COMPLETED`,
        },
        {
          icon: <MdOutlineMilitaryTech className="left-icon" />,
          title: 'Badge',
          count: 'badgeCount',
          route: '/Badge/badge',
        },
      ],
    },
  ];

  return (
    <div className="">
      <h6 className="card-header-title-label">Statistics</h6>
      <div
        style={{ '--gap': '1rem' }}
        className="dynamic-gap-v d-flex flex-column h-100"
      >
        {cardsData.map((section) => (
          <section style={{ '--gap': '1rem 0' }} className="row dynamic-gap-v">
            {section.card.map((card) => (
              <Card
                icon={card.icon}
                title={card.title}
                count={intakecount[card.count]}
                onClick={() => router.push(card.route)}
              />
            ))}
          </section>
        ))}
      </div>
    </div>
  );
};

const Card = ({ icon, title, count, onClick }) => (
  <div className="col-md-6 col-xs-12 col-sm-12" onClick={onClick}>
    <div
      className={classnames(
        styles['mb-xl-0'],
        styles['card'],
        styles['cardshade-learner'],
      )}
    >
      <div className={classnames('left', styles['left'])}>{icon}</div>
      <div
        className="card-body statistics-card-size"
        style={{ cursor: 'pointer' }}
      >
        <div className="row">
          <div className="col">
            <h2
              className={classnames(
                'mb-1',
                'learner-dashboard-counts',
                styles['learner-dashboard-counts'],
              )}
            >
              {count}
            </h2>
            <span className="view-page-title">{title}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ClassStatistics;
